<ng-container *ngIf="(isEnabled$ | async) && (hasRoute('home') || hasRoute('collections') || hasRoute('communities'))">
  <div *ngIf="route$ | async as route" class="d-inline-block float-right margin-right">
    <a [href]="route" class="btn btn-secondary" [title]="'feed.description' | translate" [attr.aria-label]="'feed.description' | translate" role="button" tabindex="0"><i class="fas fa-rss-square"></i></a>
  </div>
</ng-container>
